<section class="mod-page" data-module="roster">
  <header class="page-header">
    <div>
      <p class="eyebrow">Roster management</p>
      <h1>Officer availability</h1>
    </div>
  </header>

  @if (message()) {
    <p class="toast">{{ message() }}</p>
  }

  <div class="grid-2">
    <div class="table-wrap">
      <table>
        <thead>
          <tr>
            <th>Officer</th>
            <th>Department</th>
            <th>Availability</th>
            <th>Current Load</th>
            <th>Leave Status</th>
          </tr>
        </thead>
        <tbody>
          @for (item of roster(); track item.id) {
            <tr style="cursor:pointer" (click)="selectedId.set(item.id)" [style.background]="selected()?.id === item.id ? 'var(--module-soft)' : null">
              <td><strong>{{ item.name }}</strong><div class="muted">{{ item.role }}</div></td>
              <td>{{ item.department }}</td>
              <td><span class="pill">{{ item.availability }}</span></td>
              <td>
                <div style="display:flex;gap:.5rem;align-items:center">
                  <div class="bar-track" style="flex:1;min-width:70px"><div class="bar-fill" [style.width.%]="loadWidth(item.workload)"></div></div>
                  <span>{{ item.workload }}</span>
                </div>
              </td>
              <td>{{ formatLeaveUntil(item.leaveUntil) }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <aside style="display:grid;gap:.9rem">
      <section class="panel">
        <h2 style="font-size:1rem;margin-bottom:.65rem">Availability Calendar</h2>
        <div class="calendar-grid">
          @for (cell of calendarDays; track cell.iso) {
            <button
              type="button"
              class="calendar-cell"
              [class.active]="calendarActive(cell.iso)"
              (click)="selectDay(cell.iso)"
            >
              <div class="day">{{ cell.day }}</div>
              <div class="muted">{{ cell.monthShort }}</div>
            </button>
          }
        </div>
      </section>

      <section class="panel">
        <h2 style="font-size:1rem;margin-bottom:.65rem">Assignment Panel</h2>
        @if (selected(); as o) {
          <p><strong>{{ o.name }}</strong> · {{ o.department }}</p>
          <p class="muted" style="margin:.35rem 0 .75rem">
            {{ o.availability }} · load {{ o.workload }}
            @if (o.currentAssignment) {
              <span> · current: {{ o.currentAssignment }}</span>
            }
          </p>
          <label style="display:grid;gap:.3rem;font-size:.8rem;color:var(--ink-muted);font-weight:600">
            Hearing / task
            <input
              class="field"
              [ngModel]="assignment()"
              (ngModelChange)="assignment.set($event)"
            />
          </label>
          <div class="btn-row" style="margin-top:.75rem">
            @if (canMutate()) {
              <button type="button" class="btn primary" [disabled]="busy() || !assignment().trim()" (click)="assign()">
                {{ busy() ? 'Saving…' : 'Assign' }}
              </button>
              <button type="button" class="btn" [disabled]="busy()" (click)="remove()">Remove</button>
              <button type="button" class="btn" [disabled]="busy()" (click)="update()">Update</button>
            } @else {
              <p class="muted">View only — roster changes require peshkar / admin.</p>
            }
          </div>
        }
      </section>
    </aside>
  </div>
</section>
